export const ItemTypes = {
  ROW: "row"
}

export const CONFIRM_TRANSITION_IDS = [
    "cancel",
    "close",
    "deactivate",
    "reinstate",
    "reject",
    "remove",
    "remove",
    "retest",
    "retract",
    "unassign"
]
